import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import ReactPaginate from 'react-paginate';

import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table
} from "reactstrap";



const CityMaster = () => {

  const navigate = useNavigate();
  const [cityTable, setCityTable] = useState([]);
  const [totalPage, setTotalPage] = useState();

  const onHandleSearchKeyItem = (e) => {
    const value = e.target.value;
    getCityData(1, 10, value)
  }

  const onHandleAddCity = () => {
    navigate("/addCity")
  }

  const onHandleEditCategory = (id) => {
    let findArrayData = cityTable.find(e => e.id === id)
    navigate('/addCity', { state: { cityId: findArrayData?.id } });
  }

  const getCityData = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`api/CityMaster/allcitys?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setCityTable(response.city_MasterDetailData)
        setTotalPage(response.totalPages)
        // toast.success(response.message);
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  };

  useEffect(() => {
    getCityData();
  }, [!cityTable]);

  const handlePageClick = (data) => {
    getCityData(data.selected + 1)
  };

  const onHandleDeleteCity = async (id) => {

    const isDeleteConfirmed = window.confirm('Are you sure you want to delete this item?');
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json', // Important for file upload//s
            'accept': 'application/json'
          }
        };

        const response = await apiService.delete(`api/CityMaster/delete?cityId=${id}`, config)
        if (response.response && response.response.data.errors) {
          toast.success(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message);
          getCityData()
        }
        else {
          toast.success(response.message);
        }
      } catch (error) {
        console.log(error)
        toast.error(`SomeThing went wrong!!`);
      }
    } else {
      console.log('Deletion canceled.');
    }
  };



  return (
    <>
      <Col lg="12">
        <Card className='bg-white pd-10 card-box mb-30'>
          <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <i className="bi bi-card-text mr-2"></i>
              City Master
            </div>

            <Row className="align-items-center" style={{ marginRight: '10px', width: '300px' }}>
              <Input  id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyItem(e) }} />
            </Row>

            <Button color="primary" size="bg" onClick={onHandleAddCity}>Add City</Button>
          </CardTitle>

          <CardBody className="">
            <Table striped>
              <thead>
                <tr>
                   <th>S. no.</th>
                  <th>State Name</th>
                  <th>City Name</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {cityTable.map((item, index) => (

                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>{item?.state_name}</td>
                    <td>{item.city_name}</td>
                    <td>
                      <Button color="success" size="bg" onClick={() => onHandleEditCategory(item.id)}>
                        <i className="fas fa-edit"></i>
                      </Button>
                    </td>
                    <td>
                      <Button color="danger" size="bg" onClick={() => onHandleDeleteCity(item.id)}>
                        <i className="fas fa-trash"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </CardBody>

          <CardBody>
            {/* <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={totalPage}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              activeClassName={'active'}
            /> */}

            <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            pageCount={totalPage} // still 4000
                            marginPagesDisplayed={1} // 1 page at start & end
                            pageRangeDisplayed={2}  // visible range around selected page
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}

                            pageClassName={'page-item'}
                            pageLinkClassName={'page-link'}
                            previousClassName={'page-item'}
                            nextClassName={'page-item'}
                            previousLinkClassName={'page-link'}
                            nextLinkClassName={'page-link'}
                            breakClassName={'page-item'}
                            breakLinkClassName={'page-link'}
                        />
          </CardBody>
        </Card>
      </Col>
    </>
  )
}

export default CityMaster